<template>
    <div  class="  banner" v-if="data">
      <router-link
      
        :to="
       
           data.link
           
        "
        
        class="overflow-hidden"
      >
      <!-- :target="data && data.new_tab == 1 ? '_blank' : ''" -->
        <img loading="lazy"  :src="data.picture" class="w-100 h-100" alt="" />
      </router-link>
    </div>
  </template>
  
  <script>
  import findUrl from "@/libraries/links/LinkResolver";
  export default {
    name: "Baner",
    props: {
        data: {
        type:Object,
        default:{
            link:"/",
            new_tab:1,
            picture:""
        }
      },
    },
    methods: {
      findUrl,
    },
    computed: {
      hasAnyBanners() {
        let ok = false;
        this.banners.every(banner => {
          if (banner) {
            ok = true
            return false;
          }
          return true
        })
        return ok;
      }
    }
  };
  </script>
  
  <style scoped>
 .banner{
  border-radius: 16px;
  overflow: hidden;
 }
  .banners > a {
    /* max-height: 209px; */
  }
   </style>
  